export const trackItemDetails = item => {
  const price = item && item.selectedAmount ? item.selectedAmount : 0
  const fee = item && item.fee && item.fee.cost ? item.fee.cost : 0
  return {
    utid: item && item.utid ? item.utid : '',
    brand: item && item.brand && item.brand.name ? item.brand.name : '',
    price: parseFloat(price).toFixed(2),
    fee: parseFloat(fee).toFixed(2)
  }
}
